"use strict";

exports.__esModule = true;
var noop = function noop() {
  return undefined;
};
noop.noop = true;
exports["default"] = noop;